import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement } from "../../../types";
import { getRegistrationRequirementName } from "../../Registration/configs/helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayerStatusCell } from "../../Registration/configs/helpers/getRegistrationRequirementPayerStatusCell";

export function getRegistrationCustomRequirement(
  requirements: IRequirementResponse[]
): CustomRequirement {
  const baseRequirement = requirements[0];

  return {
    payerId: baseRequirement.payerId,
    status: baseRequirement.status,
    nameCell: {
      text: getRegistrationRequirementName(baseRequirement)
    },
    typeCell: getRequirementDefinitionTableCellProps({
      type: baseRequirement.requirementType
    }),
    clientsCell: {
      text: `${requirements.length} clients`
    },
    engagementsCell: {},
    statusCell: getRegistrationRequirementPayerStatusCell(baseRequirement),
    menuActions: []
  };
}
